import React from 'react';
import './LandingPage.css';
import {Link} from "react-router-dom";
import Header from "../header/Header";
import './HeroSection.css';
import Footer from "../footer/Footer";

const HeroSection = () => {
    return (<section className="hero-section"
                     style={{background: "url('/images/kids_puzzle.jpeg') no-repeat center center / cover"}}>
        {/* Background image is set via CSS */}
        <div className="hero-overlay">
            <div className="hero-logo">
                <img src="/images/esae-map-logo-2.png" alt="Rare Diseases Greece Logo"/>
            </div>
            <div className="hero-buttons">
                <button className="hero-button" onClick={() => window.location.href = '/register'}><b>ΕΓΓΡΑΦΕΙΤΕ</b>
                </button>
                <button className="hero-button" onClick={() => window.location.href = '/login'}><b>ΣΥΝΔΕΘΕΙΤΕ</b>
                </button>
            </div>
        </div>
    </section>);
};

const HomePage = () => {
    return <div className="homepage">
        {/* Header Section */}
        <Header/>

        <HeroSection/>

        <div className="white-rectangle"></div>

        {/* Info Section */}
        <section className="info-section">
            <div className="info-header">
                <h2>ΤΙ ΘΑ ΒΡΕΙΤΕ;</h2>
                <p>Αξιόπιστες πληροφορίες για</p>
            </div>
            <div className="info-items">
                <div className="info-item">
                    <img src="/images/info-circle_white.svg" alt="Info Icon" className="info-icon"/>
                    <p>Σπάνιες Παθήσεις</p>
                </div>
                <div className="info-item">
                    <img src="/images/plus-square_white.svg" alt="Info Icon" className="info-icon"/>
                    <p>Κέντρα Εμπειρογνωμοσύνης</p>
                </div>
                <div className="info-item">
                    <img src="/images/group_white.svg" alt="Info Icon" className="info-icon"/>
                    <p>Οργανώσεις Ασθενών</p>
                </div>
                <div className="info-item">
                    <img src="/images/microscope_white.svg" alt="Info Icon" className="info-icon"/>
                    <p>Κλινικές Μελέτες</p>
                </div>
                <div className="info-item">
                    <img src="/images/book_white.svg" alt="Info Icon" className="info-icon"/>
                    <p>Επιστημονική Βιβλιογραφία</p>
                </div>
            </div>
        </section>

        {/* Map Section */}
        <section className="map-section">
            <div className="map-container">
                <div className="map-preview">
                    <img src="/images/map_screenshot.png" alt="Map Preview"/>
                </div>
                <div className="map-info">
                    <h2>Ελληνικός Χάρτης Σπανίων Παθήσεων</h2>
                    <p>
                        Ασθενείς, Οργανισμοί Ασθενών, και Κέντρα Αναφοράς & Φροντίδας Σπάνιων Νοσημάτων στη χώρα,
                        όλοι συνδεδεμένοι σε ένα σημείο.
                    </p>
                    <Link to="/map">
                        <button className="btn-primary">Περιηγηθείτε</button>
                    </Link>
                </div>
            </div>
        </section>


        {/* Call to Action Section */}
        <section className="cta-section">
            <div className="cta-left">
                <h3>Συμβάλλετε στη Συγκέντρωση της Πληροφορίας</h3>
                <button className="cta-button" onClick={() => window.location.href = '/more'}>Περισσότερα</button>
            </div>
            <div className="cta-right">
                <img src="/images/puzzle.jpg" alt=""/>
            </div>
        </section>

        {/* Sponsors Section */}
        <footer className="footer">
            <div className="sponsors">
                <img src="/images/logos-ease-map.png" alt="Sponsors"/>
            </div>
        </footer>
        <Footer/>
    </div>;
};

export default HomePage;